import React, { useState } from 'react';
import SafeIcon from './common/SafeIcon';
import * as FiIcons from 'react-icons/fi';
import GeneratorForm from './components/GeneratorForm';
import LogTerminal from './components/LogTerminal';
import BulkResultCard from './components/BulkResultCard';
import StatsBar from './components/StatsBar';
import { processBulk } from './utils/bulkEngine';

const { FiLayers } = FiIcons;

function App() {
  const [logs, setLogs] = useState([]);
  const [isGenerating, setIsGenerating] = useState(false);
  const [bulkResult, setBulkResult] = useState(null);

  const handleGenerate = async (params, file, pageCount) => {
    setIsGenerating(true);
    setLogs([]);
    setBulkResult(null);

    const product = params.product || params.keyword.split(' ')[0] || 'GeneratedProduct';
    const finalParams = { ...params, product };

    try {
      const text = await file.text();
      const result = await processBulk(
        text, finalParams, pageCount,
        (msg) => setLogs((prev) => [...prev, msg])
      );
      if (result.success) setBulkResult(result);
    } catch (error) {
      setLogs((prev) => [...prev, `[ERROR] Pipeline failed: ${error.message}`]);
    } finally {
      setIsGenerating(false);
    }
  };

  const handleReset = () => { setBulkResult(null); setLogs([]); };

  return (
    <div className="min-h-screen bg-slate-950 text-slate-200 font-sans selection:bg-indigo-500/30">
      <header className="border-b border-slate-800/60 bg-slate-900/50 backdrop-blur-sm sticky top-0 z-10">
        <div className="max-w-7xl mx-auto px-6 py-4 flex items-center gap-4">
          <div className="p-2 bg-indigo-600 rounded-lg shadow-lg shadow-indigo-500/20">
            <SafeIcon icon={FiLayers} className="text-white text-lg" />
          </div>
          <div className="flex-1">
            <h1 className="text-lg font-bold tracking-tight text-white">Blackhat Parasite Generator</h1>
            <p className="text-xs text-slate-500">Bulk doorway-page generator — 1× LLM call per batch</p>
          </div>
          <div className="hidden md:flex items-center gap-2 px-3 py-1.5 rounded-full bg-slate-800 border border-slate-700">
            <div className="w-2 h-2 rounded-full bg-green-400 animate-pulse"></div>
            <span className="text-xs text-slate-400 font-mono">Bulk Mode</span>
          </div>
        </div>
      </header>

      <main className="max-w-7xl mx-auto px-6 py-8">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-6">
          <div className="lg:col-span-5 flex flex-col gap-4">
            <GeneratorForm onSubmit={handleGenerate} isGenerating={isGenerating} />
            <StatsBar isGenerating={isGenerating} />
          </div>
          <div className="lg:col-span-7 flex flex-col gap-4">
            <LogTerminal logs={logs} />
            {bulkResult && <BulkResultCard result={bulkResult} onReset={handleReset} />}
          </div>
        </div>
      </main>

      <footer className="border-t border-slate-800/60 mt-8 py-4 text-center">
        <p className="text-xs text-slate-600">
          Blackhat Parasite Generator — Bulk mode · Pure-JS ZIP export · Build {__BUILD_TIME__}
        </p>
      </footer>
    </div>
  );
}

export default App;